import Marquee from "react-fast-marquee";
import { LOGOS } from "../data/portfolio";

export default function TrustedMarquee() {
  return (
    <section className="py-16 md:py-24 border-y border-white/10 bg-[#070707]" data-testid="trusted-marquee">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 mb-10">
        <p className="text-xs uppercase tracking-[0.3em] text-white/40">
          Trusted by teams at world-leading brands
        </p>
      </div>
      <Marquee gradient gradientColor="#070707" gradientWidth={120} speed={40} pauseOnHover>
        {LOGOS.concat(LOGOS).map((logo, i) => (
          <span
            key={`${logo}-${i}`}
            className="font-display font-bold text-2xl md:text-4xl text-white/35 hover:text-white/80 transition-colors duration-500 mx-10 md:mx-16 whitespace-nowrap tracking-tight"
            data-testid={`logo-${i}`}
          >
            {logo}
          </span>
        ))}
      </Marquee>
    </section>
  );
}
